import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { DialogFooter } from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useIsMobile } from '@/hooks/use-mobile';
import { useLanguage } from '@/contexts/LanguageContext';
import { Loader2 } from 'lucide-react'; // ← Import du loader

interface AddLocationFormProps {
  onSubmit: (name: string) => void | Promise<void>;
  onCancel: () => void;
}

const AddLocationForm: React.FC<AddLocationFormProps> = ({ onSubmit, onCancel }) => {
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isMobile = useIsMobile();
  const { t } = useLanguage();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      setIsSubmitting(true);
      try {
        await onSubmit(name.trim());
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className={`${!isMobile ? 'h-auto' : 'h-full'} flex flex-col`}>
      <ScrollArea className={`flex-grow ${!isMobile ? 'max-h-[60vh] pb-5' : 'p-5'}`}>
        <div className="space-y-3">
          <div>
            <Label htmlFor="new-location-name">{t('locations.name')}</Label>
            <Input
              id="new-location-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter location name"
              autoFocus
            />
          </div>
        </div>
      </ScrollArea>

      <DialogFooter className={isMobile ? "px-6 py-4 border-t sticky bottom-0 bg-gray-50 z-20" : "pt-5"}>
        <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
          {t('common.cancel')}
        </Button>
        <Button type="submit" disabled={isSubmitting || !name.trim()}>
          {isSubmitting ? (
            <span className="flex items-center gap-2">
              <Loader2 className="w-4 h-4 animate-spin" />
              {t('common.loading')}
            </span>
          ) : (
            t('locations.add_location') // ou "Add Location" si pas de traduction
          )}
        </Button>
      </DialogFooter>
    </form>
  );
};

export default AddLocationForm;
